<template>
  <div class="new-gray rounded md:flex">
    <div class="px-4 pt-9 md:flex-1 md:py-6 md:pl-6">
      <h4 class="text-neutral-800 o-heading-4 mb-1" v-text="$t('Loyalty.LoyaltyProgram.ViewWebshopBlock.Title')" />
      <p class="text-neutral-800 o-body" v-text="$t('Loyalty.LoyaltyProgram.ViewWebshopBlock.Description')" />
      <div class="py-3">
        <NewButton tag="nuxt-link" to="/webshop" icon-right="new-chevron-right" color="black" variant="outline">
          {{ $t('Loyalty.LoyaltyProgram.ViewWebshopBlock.SeeWebshop') }}
        </NewButton>
      </div>
    </div>
    <div class="flex justify-end flex-1">
      <OImage v-bind="image" img-class="md:h-full rounded" />
    </div>
  </div>
</template>

<script>
import NewButton from '@/components/NewButton'
import OImage from '@/components/OImage'
import { getImagePaths } from '@/utils/general'

export default {
  name: 'ViewWebshopBlock',
  components: { NewButton, OImage },
  computed: {
    image () {
      return getImagePaths({
        path: '/images/frontend/loyalty/webshop',
        s3: true
      })
    }
  }
}
</script>

<style scoped lang="postcss">
.new-gray {
  background-color: #EBEAE5;
}
</style>
